import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Config from '../../../../Config';
import { buildUrlAndOpenSameWindow } from '../../../../utilities/StringHelpers/StringHelpers';
import Footer from '../Partials/Footer/Footer';
import { setIsSubmit , createLead, reportDWH} from '../electricCompanyLeadBlockSlice';
import SuccessIcon from '../images/success-icon.svg'
import ServiceIcon from '../images/service-icon.svg'

const ServiceMessagePage = (props) => {

  //page params
  let title = '';
  let subTitle = '';
  let iconType = '';
  let btnText = '';
  let btnFunction = null;
  let linkText = '';
  let isDisplayWhatsApp = false;
  let currentPageFunction = handlePageContinue;
  let formid = 'electricCompanyLead';
  //page params

  switch (props.serviceMessageType) {
    case "FOUND":
      props.reportDWH({ actionType: 'Check Energy Counter', status: 'Ongoing', messageText: 'Yes Smart counter - Display' });
      iconType = SuccessIcon;
      title = "מעולה! יש לך מונה חכם, \n שלב אחד כבר מאחורינו";
      subTitle = "נציג שלנו יצור קשר בזמן הקרוב";
      btnText = "הבנתי תודה";
      btnFunction = goToElectricCompanyPage;
      break;
    case "NOT_FOUND":
      props.reportDWH({ actionType: 'Check Energy Counter', status: 'Ongoing', messageText: 'No Smart counter - Display' });
      iconType = ServiceIcon;
      title = "כדי להשלים את התהליך \n נציג שלנו יצור קשר בזמן הקרוב​";
      subTitle = "";
      btnText = "הבנתי תודה";
      btnFunction = goToElectricCompanyPage;
      break;
    case "ERROR":
        props.reportDWH({ actionType: 'Error', status: 'Error', messageText: 'General Error' });
        iconType = ServiceIcon;
        title = "משהו השתבש בבדיקה";
        subTitle = "נציג שלנו יצור קשר בזמן הקרוב";
        btnText = "הבנתי תודה";
        btnFunction = goToElectricCompanyPage;
        break;
    case "NOT_FOUND_WITH_WHATSAPP":
      isDisplayWhatsApp = true;
      iconType = ServiceIcon;
      title = "חסרים לנו כמה פרטים, \n ממשיכים בווטצאפ?";
      subTitle = "";
      btnText = "לנציג אנושי ב-WhatsApp";
      btnFunction = openWhatsApp;
      linkText = "שנציג יחזור אלי";
      break;
    case "LEAD_SUCCESS":
      iconType = ServiceIcon;
      title = "תודה, נציג יחזור אליך \n מוקדם ככל האפשר!";
      btnText = "חזרה לעמוד הראשי";
      btnFunction = goToHomePage;
      break;
  }

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <Image className='icon' src={iconType} alt='' />
      <h1 className='title'>{title}</h1>
      <h2 className='sub-title'>{subTitle}</h2>
    </div>
  );

  return (
    <div className='electric-company-lead-wrapper'>
      {currentPageHeadline}
      <div className='electric-company-lead-page-content'>
        <Footer isDisplayWhatsAppIcon={isDisplayWhatsApp} btnText={btnText} onclick={currentPageFunction} linkText={linkText} onClickLink={handleOnClickLink} formid={formid} />
      </div>
    </div>
  );

  function handlePageContinue() {
    btnFunction();
  }

  function openWhatsApp(){
    //TODO: GoToWhatsApp page
  }

  function goToHomePage(){
    window.location.href = Config.staticWebSiteUrl;
  }

  function goToElectricCompanyPage(){
    buildUrlAndOpenSameWindow(props.energyPageLink);
  }

  function handleOnClickLink() {
    props.createLead();
  }


};

const mapStateToProps = (state) => {
  return {
    isSubmit: state.electricCompanyLeadBlock.isSubmit,
    serviceMessageType: state.electricCompanyLeadBlock.serviceMessageType,
    energyPageLink: state.electricCompanyLeadBlock.cmsBlockData.energyPageLink,
    //other states
  };
};

const mapDispatchToProps = {
  setIsSubmit,
  createLead,
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceMessagePage);
